import { inject, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

import { AppMenuitemComponent } from './app.menuitem.component';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  standalone: true,
  imports: [AppMenuitemComponent],
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  public layoutService = inject(LayoutService);

  constructor() {}

  ngOnInit() {
    this.model = [
      {
        label: ' ',
        items: [
          { label: 'Αρχική', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
          {
            label: 'Συνομιλίες',
            icon: 'pi pi-fw pi-comments',
            routerLink: ['/chat'],
          },
          {
            label: 'Διαχείριση Δικτύου',
            icon: 'pi pi-fw pi-user-edit',
            routerLink: ['/manage-network'],
          },
          {
            label: 'Διαχείριση Αρχείων',
            icon: 'pi pi-fw pi-file-edit',
            routerLink: ['/manage-files'],
          },
          {
            label: 'Επείγουσες Ειδοποίησεις',
            icon: 'pi pi-fw pi-bell',
            routerLink: ['/emergency-alerts'],
          },
        ],
      },
    ];
  }
}
